var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bi-common-title"},[_c('div',{staticClass:"icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }